// Third-party
import React from 'react';
import classNames from 'classnames';

// Namespaces
import * as ProposalNS from '../../Proposal';

type Props = {
  texts: ProposalNS.ProposalText[];
  className?: string;
};

/* eslint-disable-next-line react/prefer-stateless-function */
class ProposalText extends React.Component<Props> {
  render() {
    const { texts, className } = this.props;

    return (
      <div className={classNames('proposal-text', className)}>
        {texts &&
          texts.map(text => {
            const tag = text.tag || 'span';

            return React.createElement(tag, { className: text.className, key: text.text }, text.text);
          })}
      </div>
    );
  }
}

export type ProposalTextProps = Props;

export default ProposalText;
